import { z } from "zod/v4";

export const LoopWebhookRequestPathParamsSchema = z.object({
  shopId: z.string(),
});

export type LoopWebhookRequestPathParamsType = z.infer<
  typeof LoopWebhookRequestPathParamsSchema
>;
